import _request from "../_request";

const carrierSubscribe = async (ISO, data) => {
  const config = {
    url: "/subscribers",
    method: "post",
    ISO,
  };
  return _request(config, data);
};

const verifyCode = async (ISO, data) => {
  const config = {
    url: `/subscribers/verify`,
    method: "post",
    ISO,
  };
  return _request(config, data);
};

const sendOtp = async (ISO, data) => {
  const config = {
    url: "/subscribers/send-otp",
    method: "post",
    ISO,
  };
  return _request(config, data);
};

const subscribeWithEmail = async (ISO, data) => {
  const config = {
    url: "/subscribers/subscribe-with-email",
    method: "post",
    ISO,
  };
  return _request(config, data);
};

const subscribeService = {
  carrierSubscribe,
  verifyCode,
  sendOtp,
  subscribeWithEmail,
};

export default subscribeService;
